import { initPreferences } from '@platform/ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import './styles.css';
import { ConnectivityBoundary } from './connectivity';
import { registerPwa } from './pwa';

// Apply theme + density before the first render (no flash, DESIGN.md §4).
initPreferences();
registerPwa();

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

createRoot(root).render(
  <StrictMode>
    <ConnectivityBoundary><App /></ConnectivityBoundary>
  </StrictMode>,
);
